module.exports = __webpack_public_path__ + "img/spongebob-squarepants-global-demand-chart.fdcc0e33.webp";